import { useNavigate, useLocation } from 'react-router-dom'
import { strings } from '@/strings'

export function SignInBanner() {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const returnTo = encodeURIComponent(pathname)

    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-50 flex justify-center"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <div className="w-full max-w-[480px] bg-white dark:bg-gray-900 border-t border-border-light dark:border-border-dark px-4 py-3 flex items-center justify-between gap-3">
                <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
                    {strings.publicView.bannerMessage}
                </p>
                <button
                    onClick={() => navigate(`/login?returnTo=${returnTo}`)}
                    className="flex-shrink-0 px-4 py-1.5 rounded-full bg-blue-500 text-white text-sm font-semibold hover:bg-blue-600 transition-colors"
                >
                    {strings.publicView.bannerCta}
                </button>
            </div>
        </div>
    )
}
